export default "__VITE_ASSET__BPXiRpDR__"